






































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { IBudget, ICompetitor } from "../vuex/modules/coupon/interfaces";

@Component
export default class FormCompetitor extends Vue {
  @Prop(Function) coverValue!: () => void;
  @Getter("getBudget", { namespace: "coupon" })
  budget!: IBudget;
  @Getter("getCompetitor", { namespace: "coupon" }) competitor!: ICompetitor;
  @Getter("getListCompetitor", { namespace: "coupon" })
  listCompetitor!: string[];
  listInverter = [
      'Fronius', 'Growatt',
      'Renovigi', 'Sungroe',
      'Solis', 'APSystems',
      'SMA', 'ABB(Fimer)',
      'WEG', 'SolarEdge',
      'Hoymiles', 'PHB',
      'Goodwe', 'Canadian',
      'Refusol', 'Sofar',
      'SAJ', 'Deye',
      'Intelbras', 'Huawei',
      'KSTAR', 'Kehua'
  ]
  listStructure = [
      'Solar Group', 'Romagnole',
      'K2 Systems', 'SSM',
      'Spin', 'PHB',
      'Politec', '2p acessórios',
      'Renovigi', 'Fotofix',
      'Sices', 'Perfil Solar',
      'GF2', 'Tritec',
      'Solarfix', 'Artsing',
      'Intelbras', 'WEG',
      'IBRAP', 'NTC',
      'Metal light', 'Fotus'
  ]
  listPanel = [
      'Canadian', 'BYD',
      'Trina', 'Jinko',
      'Risen', 'DAH Solar',
      'Ulica', 'JA solar',
      'Sunova', 'Longi',
      'GCL', 'Intelbras',
      'Renovigi', 'ZNShine',
      'Amerisolar', 'Osda',
      'Q-Cells', 'Talesun',
      'Jetion', 'Yingli',
      'Kript', 'Luxen',
      'Astronergy', 'WEG',
      'Helius', 'Axitec',
      'Sunergy', 'Balfar',
      'QXPV', 'Empalux',
      'PHB', 'Seraphim',
      'Sices', 'Belenergy',
      'Renesola', 'Resun',
      'Leapton'
  ]
  discountActive = 0;
  valueRoof = 0;

  public plusUseCoupon(index: number): void {
    if (
      !(
        this.budget.couponsActive[index].use >=
        this.budget.couponsActive[index].maxUse
      )
    ) {
      this.budget.couponsActive[index].use += 1;
      this.budget.discountsActive += this.budget.couponsActive[index].value;
    }
  }

  @Watch("budget.discountsActive")
  onBudgetDiscountsActiveChange(): void {
    this.formatOffer();
    if (
      this.competitor.valueBudget != "" &&
      this.competitor.powerPanel != "" &&
      this.competitor.amountPanel != ""
    )
      this.coverValue();
  }

  public generatePowerSystemCompetitor(): void {
    this.formatOffer();
    this.formatPowerPanel();
    this.formatAmountPanel();
    this.formatBudgetValue();
    let wattValueCompetitor = 0;
    let wattValueSou =
      this.budget.powerPanel !== 0
        ? this.budget.equipamentValue /
          ((this.budget.powerPanel * this.budget.amountPanel) / 1000)
        : 0;

    this.competitor.powerSystem =
      (this.competitor.amountPanel * this.competitor.powerPanel) / 1000;

    if (this.competitor.powerSystem !== 0) {
      this.competitor.wattValue =
        this.competitor.valueBudget / this.competitor.powerSystem;
      if (!isNaN(this.competitor.wattValue)) {
        wattValueCompetitor = this.competitor.wattValue;
      }
    }

    if (wattValueSou <= wattValueCompetitor) {
      this.competitor.valueRoof = this.budget.value;
    } else {
      if (
        wattValueCompetitor * this.budget.powerSystem <=
        this.competitor.valueBudget
      ) {
        if (this.competitor.valueBudget == "") {
          this.competitor.valueRoof = 0;
        } else {
          this.competitor.valueRoof = parseFloat(this.competitor.valueBudget);
        }
      } else {
        this.competitor.valueRoof =
          wattValueCompetitor * this.budget.powerSystem;
      }
    }
    this.coverValue();
  }

  public formatPowerPanelSou(): void {
    const stringPowerPanel = this.budget.powerPanel.toString();
    if (this.budget.powerPanel == "") {
      return;
    } else {
      this.budget.powerPanel = stringPowerPanel.replace(
        /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-, "]+/i,
        ""
      );
      if (
        !isNaN(this.budget.powerPanel) &&
        this.budget.powerPanel != "" &&
        this.budget.amountPanel > 0
      ) {
        this.budget.powerSystem =
          (this.budget.powerPanel * this.budget.amountPanel) / 1000;
      }
    }
  }

  public formatPowerPanel(): void {
    const stringPowerPanel = this.competitor.powerPanel.toString();
    this.competitor.powerPanel = stringPowerPanel.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-, "]+/i,
      ""
    );
  }

  public formatPowerInvertersSou(): void {
    const stringPowerInveters = this.budget.powerInverter.toString();
    this.budget.powerInverter = stringPowerInveters.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-, "]+/i,
      ""
    );
  }

  public formatPowerInveters(): void {
    const stringPowerInveters = this.competitor.powerInverter.toString();
    this.competitor.powerInverter = stringPowerInveters.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-, "]+/i,
      ""
    );
  }

  public formatBudgetValue(): void {
    const stringBudgetValue = this.competitor.valueBudget.toString();
    this.competitor.valueBudget = stringBudgetValue.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-, "]+/i,
      ""
    );
  }

  public formatAmountInverters(): void {
    const stringAmountInverters = this.competitor.amountInverter.toString();
    this.competitor.amountInverter = stringAmountInverters.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-,. "]+/i,
      ""
    );
  }

  public formatOffer(): void {
    const stringOffer = this.competitor.offer.toString();
    this.competitor.offer = stringOffer.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-,. "]+/i,
      ""
    );
  }

  public formatAmountPanel(): void {
    const stringAmountPanel = this.competitor.amountPanel.toString();
    this.competitor.amountPanel = stringAmountPanel.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-,. "]+/i,
      ""
    );
  }
}
